const SUPPORTED_CURRENCIES = ['EUR', 'USD', 'GBP', 'MXN'] as const

export type CurrencyFormat = (typeof SUPPORTED_CURRENCIES)[number]

export function currencyFormatters(
  currency: CurrencyFormat,
  milis = false
): Intl.NumberFormat {
  const config = {
    style: 'currency',
    currency: currency ?? 'EUR',
    maximumFractionDigits: milis ? 3 : 2
  } as const
  const formats = {
    EUR: 'es-ES',
    USD: 'en-EN',
    GBP: 'en-EN',
    MXN: 'es-MX'
  } as const
  return new Intl.NumberFormat(formats[currency], config)
}

export function currencyFilter(
  value: number,
  currency: CurrencyFormat = 'EUR',
  milis = false
): string {
  const decimalValue = milis ? value / 1000 : value / 100
  if (!SUPPORTED_CURRENCIES.includes(currency)) {
    return currencyFormatters('EUR', milis).format(decimalValue)
  }
  return currencyFormatters(currency, milis).format(decimalValue)
}

export function currencySymbol(currency: CurrencyFormat = 'EUR'): string {
  return currencyFilter(0, currency)
    .replace(/\d|[,.]/g, '')
    .trim()
}
